import { render, staticRenderFns } from "./BillingsSettings.vue?vue&type=template&id=341dd0cc&"
import script from "./BillingsSettings.vue?vue&type=script&lang=js&"
export * from "./BillingsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports